import type { EmailTemplate } from "@/domains/communication/api/types";

export function renderTemplate(
  template: Pick<EmailTemplate, "subject" | "body">,
  variables: Record<string, string>,
): { subject: string; body: string } {
  const apply = (input: string): string =>
    input.replace(/\{\{(\w+)\}\}/g, (_, key: string) => variables[key] ?? `{{${key}}}`);
  return {
    subject: apply(template.subject),
    body: apply(template.body),
  };
}
